import type { OnNextRunState } from './types';

/** Run telemetry hooks before leaving the current page. */
export function finishCurrentPage(run: OnNextRunState): void {
  run.trackPageTime(run.currentPageIndex);
  run.trackOptionalSkips(run.currentPageIndex);
  run.checkBacktrackChanges(run.currentPageIndex);
}
